
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wochenbettbetreuung",
      function () {
        return require("private-next-pages/wochenbettbetreuung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wochenbettbetreuung"])
      });
    }
  